import MaintenanceLogCreate from './create';
import MaintenanceLogList from './list';
import MaintenanceLogShow from './show';
import MaintenanceLogEdit from './edit';

export default {
    create: MaintenanceLogCreate,
    list: MaintenanceLogList,
    show: MaintenanceLogShow,
    edit: MaintenanceLogEdit
};